import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@blueprintjs/core';
import ModalDialog from 'shared/modal/dialog';
import {
  FilterGroup,
  FilterGroupMenuActionsType,
} from 'data/filterGroup/filterGroup.types';
import './filter-group-action-menu.scss';

type Props = {
  selectedItem?: FilterGroup;
  hasPrivilegesToCreate: boolean;
  hasPrivilegeToDelete: boolean;
  onEdit: () => void;
  onDelete: () => void;
}

const FilterGroupMenu: FunctionComponent<Props> = ({
  selectedItem,
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  onEdit,
  onDelete,
}: Props) => {

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    setIsDeleteDialogOpen(false);
  };

  if (selectedItem == null) {
    return null;
  }

  return (
    <div data-testid="FilterGroupMenu" className="filter-group-action-menu">
      {hasPrivilegesToCreate && (
        <Button
          className="filter-group-action-menu-button"
          data-testid={`${FilterGroupMenuActionsType.Edit}-button`}
          text={t('filterGroup.grid.edit')}
          onClick={onEdit}
        />
      )}
      {hasPrivilegeToDelete && (
        <Button
          className="filter-group-action-menu-button"
          data-testid={`${FilterGroupMenuActionsType.Delete}-button`}
          text={t('filterGroup.grid.delete')}
          onClick={handleOpenDeleteDialog}
        />
      )}
      <ModalDialog
        width="500px"
        isOpen={isDeleteDialogOpen}
        title={t('filterGroup.deletePopup.title')}
        displayMessage={
          t('filterGroup.deletePopup.message', { name: selectedItem.fgId })
        }
        actionText={t('filterGroup.deletePopup.action')}
        onSubmit={handleDelete}
        onClose={handleCloseDeleteDialog}
      />
    </div>
  );
};

export default FilterGroupMenu;
